var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBxHealth(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "b10b4dfd-7185-40aa-8b28-8925845c14cd",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "bf3fc31c-4158-4aed-9859-f30bafec1ff3",
    "data-name": "Path 32",
    d: "M14.633,11.007A2.38,2.38,0,0,0,12.609,14.6c-.819.843-1.142,1.138-1.649,1.138h-1c-1.46,0-1.526-1.756-1.529-1.95v-.622H8.9a3.742,3.742,0,0,0,3.722-3.757v-3.2c0-2.493-1.741-2.493-2.485-2.493a.811.811,0,0,0-.276.049A.741.741,0,1,0,8.38,3.723a.468.468,0,0,0,0,.053V5.3a.741.741,0,1,0,1.481.065V5.315a.787.787,0,0,0,.276.049,1.779,1.779,0,0,1,.691.083c.059.041.16.248.16.763v3.2a2.1,2.1,0,0,1-2.088,2.1H6.712A2.1,2.1,0,0,1,4.624,9.408v-3.2c0-.475.091-.7.169-.757a1.8,1.8,0,0,1,.718-.089h0A.74.74,0,0,0,6.99,5.3V3.776a.74.74,0,0,0-1.475-.06h0c-.758,0-2.525,0-2.525,2.494v3.2a3.742,3.742,0,0,0,3.722,3.754h.469v.626C7.188,14.9,7.781,17,9.96,17h1c1.051,0,1.657-.6,2.55-1.525a2.32,2.32,0,0,0,1.123.288,2.377,2.377,0,1,0,0-4.754m0,3.2a.826.826,0,1,1,.819-.833v.007a.823.823,0,0,1-.819.826",
    style: {
      fill: "#005a7d"
    }
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBxHealth);
export default __webpack_public_path__ + "static/media/bxHealth.478f6ce54ed6f3806b283163d244b5c4.svg";
export { ForwardRef as ReactComponent };